import React, { useState } from 'react'
import Layout from "./../shared/components/organisms/layout/layout"
import SEO from "./../shared/seo"
import useMediaQuery from "../utils/useMediaQuery"
import ProfileContent from '../components/organisms/profile-content/profile-content'


const Perfil = () => {


  const isMobile = useMediaQuery()
  const [modalActive, setModalActive] = useState()
  return (
    <Layout mobile={isMobile} modalActive={modalActive}>
      <SEO title="Embajadoras 2021" description="Embajadoras 2021" />
      <ProfileContent />
    </Layout>
  )
}

export default Perfil
